import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(() => ({
  small: {
    maxHeight: 28,
  },
}));
